AppTabs.createTab({

    name: 'sample',
    icon: 'flask',
    text: 'Sample',
    //preload: 'vmSampleLogin',
    actionElementClasses: ['sample-link'],
    create: function (init) {
        'use strict'

        const tab = this;
        var vmProject = null;
        var projectTab = null;
        const sampleDataFields = [
            'JobID',
            'SampleDescription',
            'SampleFromDate',
            'SampleToDate',
            'EDISampleNumber',
            'Preservation',
            'PreservedBy',
            'CollectionMethod',
            'SampleMatrix',
            'DissolvedOrTotal',
            'LabComment',
            'ReportComment',
            'SampleLocationID',
        ];

        function getYesterdayISOString() {
            let yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return getLocalISODate(yesterday);
        }

        // Fake constructor
        function SampleData() {
            let data = {
                Tests: [],
                LoginDate: getLocalISODate()
            };
            sampleDataFields.forEach(property => data[property] = null);
            const yesterday = getYesterdayISOString();
            data.SampleFromDate = yesterday;
            data.SampleToDate = null; //yesterday;
            return data;
        }

        // Fake constructor
        window.SampleDuplicationChecklist = function () {
            let data = {};
            sampleDataFields.forEach(property => data[property] = false);
            return data;
        }

        init.setController(new TabControllerVue({
            el: '#v-sample-login',
            store, // vuex store
            created: function () {
                if (!this.$store.state.sampleDuplicationChecklist.length) {
                    this.$store.dispatch('localLoadSampleDuplicationChecklist');
                }
            },
            lockUpdates: true,
            methods: {
                resetData() {
                    this.sampleNumberInput = null;
                    this.sampleNumber = null;
                    this.sampleTests = [];
                    this.sampleType = 'new';
                    this.sampleLoading = false;
                    this.job = null;
                    this.jobData = null;
                    this.jobNumber = null;
                    this.jobClientName = null;
                    this.jobClientId = null;
                    this.sampleDataModified = false;
                    this.sampleData = SampleData();
                    this.sample = null;
                    this.location = null;
                    this.jobLoading = false;
                    this.clientTestLists = [];
                    this.inputSampleExists = false;
                },
                onOpenTab() {
                    tab.autofocus();
                },
                // Event safe
                clearSampleData: function (then = null) {
                    // Ignore Event
                    if (then instanceof Event) { then = null; }
                    tab.autofocus();
                    this.reset(then);
                },
                // Event safe
                updateSampleData: function (onSuccess = null, onError = null) {
                    // Ignore Event
                    if (onSuccess instanceof Event) { onSuccess = null; }
                    const tabController = this;
                    tabController.sampleLoading = true;
                    //Update Sample Data, Test Data
                    window.ajaxCall({
                        data: {
                            action: 'update_sample_data',
                            sample_data: this.sampleData,
                        },
                        onSuccess: function (data) {
                            tabController.sampleDataModified = false;
                            tab.drawTable();
                            tabController.sampleLoading = false;
                            if (typeof onSuccess == 'function') { onSuccess(); }
                        },
                        onError: function () {
                            tabController.sampleLoading = false;
                            if (typeof onError == 'function') { onError(); }
                        },
                    });
                },
                // Event safe
                loadSample: function (sampleNumber = null, onSuccess = null, onError = null) {
                    // Ignore Event or fill with fallback on selected sample number
                    if (sampleNumber === null || sampleNumber instanceof Event) {
                        sampleNumber = this.sampleNumberInput;
                    }
                    this.sampleLoading = true;
                    const tabController = this;
                    window.ajaxCall({
                        data: {
                            action: 'get_sample_data',
                            sample_number: sampleNumber
                        },
                        successMessage: 'Successfully Loaded Sample Data',
                        onSuccess: function (data) {
                            data = data['data'];
                            sampleNumber = data['SampleNumber'];
                            tabController.sampleNumber = sampleNumber;
                            tabController.sampleNumberInput = sampleNumber;
                            tabController.sample = { id: data['SampleID'], text: sampleNumber };

                            tabController.lockUpdates('loadSample');
                            data.AsIs = data.AsIs && !!parseInt(data.AsIs);
                            data.AsDryWeight = data.AsDryWeight && !!parseInt(data.AsDryWeight);
                            tabController.sampleData = data;
                            tabController.location = tabController.locationOptions
                                && tabController.locationOptions.find(l => l.id == data['SampleLocationID']) || null;
                            //tests related to sample from database
                            const tests = data['Tests'] || [];
                            //check for sample's tests and tests from vue state/localStorage
                            if (tests.length && tabController.testList) {
                                //for each test ID from the database, push the complete test info object to the array we'll use for display
                                let mergedSampleTests = [];
                                tests.forEach(db_test => {
                                    tabController.testList.forEach(testInfo => {
                                        if (db_test["TestId"] == parseInt(testInfo.id)) {
                                            let testObject = {
                                                "testId": db_test["TestId"],
                                                "testName": testInfo.testName,
                                                "resultId": db_test["ResultId"],
                                                "sampleId": db_test["SampleId"]
                                            };
                                            mergedSampleTests.push(testObject);
                                        }
                                    });
                                });
                                //sort the tests by name and assign the tests to the test list model for display in the select tests UI component
                                tabController.sampleTests = mergedSampleTests.sort((a, b) => (a.testName > b.testName) ? 1 : -1)
                            }
                            tabController.sampleLoading = false;
                            tabController.unlockUpdatesLater('loadSample', () => {
                                tabController.loadJobData(tabController.sampleData['JobID'], true /* by ID */, onSuccess, onError);
                                tab.autofocus();
                            });
                        },
                        onError: function () {
                            tabController.sampleLoading = false;
                            if (typeof onError == 'function') { onError(); }
                        }
                    });
                },
                newSample: function (sampleData, onSuccessOrEvent = null, onError = null) {
                    // Ignore Event
                    if (onSuccessOrEvent instanceof Event) { onSuccessOrEvent = null }

                    this.sampleLoading = true;
                    //this.sampleTests   = [];

                    const tabController = this;
                    window.ajaxCall({
                        data: {
                            action: 'get_new_sample_data',
                            sample_number: tabController.sampleNumberInput,
                            sample_data: sampleData,
                        },
                        successMessage: 'Successfully Loaded New Sample Data',
                        onSuccess: function (response) {
                            tabController.resetData();
                            var data = response['data'];
                            if (typeof response['SampleID'] == 'object')
                                data = response['SampleID'];
                            // make a sample object from the name and id
                            const sampleId = data['SampleID'];
                            tabController.sample = { id: sampleId, text: data['SampleNumber'] };
                            tabController.sampleNumber = data['SampleNumber'];
                            tabController.sampleNumberInput = tabController.SampleNumber;
                            tabController.lockUpdates('newSample ajaxCall onSuccess');
                            tabController.sampleData = data;
                            tabController.location = tabController.locationOptions && tabController.locationOptions.find(l => l.id == data['SampleLocationID']) || null;
                            tabController.sampleLoading = false;
                            let mergedSampleTests = [];
                            if (data['Tests'] && data['Tests'] instanceof Array) {
                                data['Tests'].forEach(test => {
                                    tabController.testList.forEach(testInfo => {
                                        if(test["TestId"] == parseInt(testInfo.id)) {
                                            let testObject = {
                                                "testId" : test["TestId"],
                                                "testName" : testInfo.testName,
                                                "resultId" : test["ResultId"],
                                                "sampleId" : test["SampleId"]
                                            };
                                            mergedSampleTests.push(testObject);
                                        }
                                    });
                                });
                                //sort the tests by name and assign the tests to the test list model for display in the select tests UI component
                                tabController.sampleTests = mergedSampleTests.sort((a, b) => (a.testName > b.testName) ? 1 : -1);
                            }
                            tabController.unlockUpdatesLater('newSample ajaxCall onSuccess', () => {
                                tabController.loadJobData(data['JobID'], true /* by ID */, onSuccessOrEvent, onError);
                                tab.drawTable();
                                tab.autofocus();
                                if (projectTab)
                                    projectTab.drawTable();
                            });
                        },
                        onError: function () {
                            tabController.sampleLoading = false;
                            if (onError) { onError(); }
                        }
                    });
                },
                // Event safe
                createBlankSample: function (onSuccessOrEvent = null, onError = null) {
                    const yesterday = getYesterdayISOString();
                    return this.newSample({
                        JobID: null === this.jobData ? vmProject.JobID : this.jobData.JobID,
                        //Tests: ( this.sampleTests || [] ).map( test => parseInt( test.id ) ),
                        SampleLocationID: 1,
                        SampleFromDate: yesterday,
                        SampleToDate: null, //yesterday,
                        LoginDate: null === this.jobData ? vmProject.LoginDate : this.jobData.LoginDate,
                    }, onSuccessOrEvent, onError);
                },

                doCreateNew() { return this.createBlankSample(); },

                // Event safe
                duplicateSample: function (onSuccessOrEvent = null, onError = null) {
                    const sampleData = {};

                    sampleData['Tests'] = this.sampleData.Tests;
                    sampleData['JobID'] = this.sampleData.JobID;
                    sampleData['SampleLocationID'] = this.sampleData.SampleLocationID;
                    const yesterday = getYesterdayISOString();
                    sampleData['SampleFromDate'] = yesterday;
                    sampleData['SampleToDate'] = null; //yesterday;
                    sampleDataFields.filter(field => field != 'LoginDate').forEach(field => {
                        sampleData[field] = this.sampleData[field];
                    });
                    return this.newSample(sampleData, onSuccessOrEvent, onError);
                },

                doDuplicate() { return this.duplicateSample(); },

                // Event safe
                partiallyCopySample: function (onSuccessOrEvent = null, onError = null) {
                    const data = {};

                    data['Tests'] = this.sampleData.Tests;
                    data['JobID'] = this.sampleData.JobID;
                    const yesterday = getYesterdayISOString();
                    data['SampleFromDate'] = yesterday;
                    data['SampleToDate'] = null;
                    sampleDataFields.filter(field => this.sampleDuplicationChecklist[field]).forEach(field => {
                        data[field] = this.sampleData[field];
                    });
                    return this.newSample(data, onSuccessOrEvent, onError);
                },

                //doLogin() { return this.partiallyCopySample(); },

                doPartialCopy() { return this.partiallyCopySample(); },

                // Event safe
                checkForSample: function (sampleNumber = null, onSuccess = null, onError = null) {
                    // Ignore Event or fill with fallback on selected sample number
                    if (sampleNumber === null || sampleNumber instanceof Event) {
                        sampleNumber = this.sampleNumberInput;
                    }
                    if (sampleNumber == '' || !sampleNumber || !parseInt(sampleNumber)) {
                        this.inputSampleExists = false;
                        return;
                    }
                    const tabController = this;
                    window.ajaxCall({
                        data: {
                            action: 'check_for_sample',
                            sample_number: sampleNumber
                        },
                        onSuccess: function (data) {
                            tabController.inputSampleExists = data['data'];
                            onSuccess && onSuccess();
                        },
                        onError: onError,
                    });
                },
                loginSampleFromJobId: function (jobId, onSuccess = null, onError = null) {
                    this.loadJobData(jobId, true /* by ID */, () => this.createBlankSample(onSuccess, onError), onError);
                },
                deleteSample: function (onSuccess = null, onError = null) {
                    const tabController = this;
                    window.ConfirmationModalManager.show({
                        title: 'Confirm Sample Deletion',
                        message: 'Are you sure you want to permanently delete Sample "'
                            + tabController.sampleData.SampleNumber
                            + '"?',
                        buttonText: 'Delete',
                        callback: function () {
                            window.ajaxCall({
                                data: {
                                    action: 'delete_sample',
                                    sample_id: tabController.sample.id,
                                    //action: 'delete_sample_by_number',
                                    //sample_number: tabController.sampleData.SampleNumber,
                                },
                                successMessage: 'Successfully Deleted Sample',
                                onSuccess: function () {
                                    tabController.clearSampleData(onSuccess);
                                    tab.drawTable();
                                    tab.autofocus();
                                    if (projectTab)
                                        projectTab.drawTable();
                                },
                                onError: function () { onError && onError() },
                            });
                        },
                    });
                },
                updateJobClientName: function () {
                    if (this.jobData && this.jobData.ClientID && this.clients) {
                        for (client in this.clients) {
                            if (this.client && this.jobData && this.client.id == this.jobData.ClientID) {
                                this.jobClientName = client.text;
                                break;
                            }
                        };
                    }
                },

                /**************************************
                Jobs
                **************************************/
                loadJobData: function (jobNumberOrId = null, isId = false, onSuccess = null, onError = null) {
                    if (this.jobLoading) { return; }
                    this.jobLoading = true;
                    if (!jobNumberOrId) {
                        this.job = null;
                        this.jobNumber = null;
                        this.lockUpdates('loadJobData clear');
                        this.jobData = null;
                        this.jobLoading = false;
                        this.clientTestLists = [];
                        this.unlockUpdatesLater('loadJobData clear', onSuccess);
                        return;
                    }
                    // if event grab target value
                    if (jobNumberOrId instanceof Event) { jobNumberOrId = jobNumberOrId.target.value; }
                    const tabController = this;
                    window.ajaxCall({
                        data: {
                            action: 'get_job_data',
                            job_number: isId ? null : jobNumberOrId,
                            job_id: isId ? jobNumberOrId : null,
                        },
                        successMessage: 'Successfully Loaded Job Data',
                        onSuccess: function (data) {
                            data = data['data'];
                            const jobNumber = data['JobNumber'];
                            const jobID = data['JobID'];
                            tabController.job = { id: jobID, text: jobNumber };
                            tabController.getClientInformation(data.ClientID);
                            tabController.lockUpdates('loadJobData ajaxCall onSuccess');
                            if (tabController.jobNumber != jobNumber) { tabController.jobNumber = jobNumber; }
                            tabController.jobData = data;
                            tabController.unlockUpdatesLater('loadJobData ajaxCall onSuccess', () => {
                                if (tabController.sampleData['JobID'] != jobID) { tabController.sampleData['JobID'] = jobID }
                                tabController.jobLoading = false;
                                tabController.loadClientTestLists(onSuccess, onError);
                            });
                        },
                        onError: function (err) {
                            console.error(err);
                            tabController.jobLoading = false;
                        }
                    });
                },
                loadJobs() {
                    const tabController = this;
                    window.ajaxCall({
                        data: {
                            action: 'get_job_list',
                        },
                        successMessage: 'Successfully Loaded Job List',
                        onSuccess: function (data) {
                            tabController.jobs = data.data;
                        },
                    });
                },
                editJob: function () {
                    vmProject.clearProjectData();
                    vmProject.loadProject(this.jobNumber, projectTab.show);
                },

                /**************************************
                Samples
                **************************************/
                loadSamples() {
                    const tabController = this;
                    window.ajaxCall({
                        data: {
                            action: 'get_sample_list',
                        },
                        successMessage: 'Successfully Loaded Samples',
                        onSuccess: function (data) {
                            tabController.samples = data.data;
                        },
                    });
                },
                loadJobSamples(job_id) {
                    const tabController = this;
                    window.ajaxCall({
                        data: {
                            action: 'get_job_sample_list',
                            job_id: job_id
                        },
                        successMessage: 'Successfully Loaded Job Samples',
                        onSuccess: function (data) {
                            tabController.samples = data.data;
                        },
                    });
                },


                clearSampleTests(callback) {
                    this.sampleTests = [];
                    const tabController = this;
                    tabController.removeTestFromSample(null, true, callback);
                },


                loadClientTestLists: function (onSuccess = null, onError = null) {
                    if (!this.jobData || !this.jobData.ClientID) { return; }
                    const tabController = this;
                    this.clientTestList = null;
                    window.ajaxCall({
                        data: {
                            action: 'get_client_test_lists',
                            client_id: this.jobData.ClientID,
                        },
                        successMessage: 'Successfully Loaded Client Test Lists',
                        onSuccess: function (response) {;
                            tabController.clientTestLists = response.data;
                            tabController.clientTestNames = tabController.clientTestLists ? tabController.clientTestLists.map(list => list.text) : [];

                            const comboTests = tabController.testCombos ? tabController.testCombos.map(
                                function(element) {
                                    element.ClientId = tabController.jobData.ClientID;
                                    return element;
                                }): [];
                                
                            const allTests = tabController.clientTestLists.concat(comboTests);
                            const datalist = document.getElementById('datalist-test-lists');

                            while (datalist.firstChild)
                                datalist.removeChild(datalist.firstChild);

                            allTests.forEach(function (value) {
                                if (!value) { return; }
                                const option = document.createElement('option');
                                option.text = value.text;
                                option.title = value.ClientId;
                                option.value = value.id;
                                datalist.append(option);
                            });

                            if (onSuccess) { onSuccess(); }
                        },
                        onError: function () {
                            if (onError) { onError(); }
                        },
                    });
                },

                addClientTestListTests: function (clientTestList, onSuccess = null, onError = null) {
                    if (!clientTestList || !('id' in clientTestList)) { return; }
                    const tabController = this;
                    window.ajaxCall({
                        data: {
                            action: 'get_sample_client_test_list_tests',
                            client_test_list_id: clientTestList.id,
                            add_to_sample: true,
                            sample_id: tabController.sampleData.SampleID
                        },
                        successMessage: 'Successfully Added Client Test List Tests',
                        onSuccess: function (response) {
                            //retrieve the tests available by ID and then concatenate them to the sampleTests
                            let sampleData = response.data;
                            let mergedSampleTests = [];
                            sampleData.Tests.forEach(test => {
                                tabController.testList.forEach(testInfo => {
                                    if(test["TestId"] == parseInt(testInfo.id)) {
                                        let testObject = {
                                            "testId" : test["TestId"],
                                            "testName" : testInfo.testName,
                                            "resultId" : test["ResultId"],
                                            "sampleId" : test["SampleId"]
                                        };
                                        mergedSampleTests.push(testObject);
                                    }
                                });
                            });
                            //sort the tests by name and assign the tests to the test list model for display in the select tests UI component
                            tabController.sampleTests = mergedSampleTests.sort((a, b) => (a.testName > b.testName) ? 1 : -1);
                        },
                        onError: function () {
                            if (onError) { onError(); }
                        },
                    });
                },
                addTestToSample: function(testIds) {
                    const tabController = this;
                    tabController.sampleLoading = true;
                    //Update Sample Data, Test Data
                    window.ajaxCall({
                        data : {
                            action: 'add_tests_to_sample',
                            sample_id: this.sampleData.SampleID,
                            test_ids: testIds
                        },
                        onSuccess : function(data) {
                            //console.log(data);
                            let sampleData = data.data;
                            let mergedSampleTests = [];
                            sampleData.Tests.forEach(db_test => {
                                tabController.testList.forEach(testInfo => {
                                    if(db_test["TestId"] == parseInt(testInfo.id)) {
                                        let testObject = {
                                            "testId" : db_test["TestId"],
                                            "testName" : testInfo.testName,
                                            "resultId" : db_test["ResultId"],
                                            "sampleId" : db_test["SampleId"]
                                        };
                                        mergedSampleTests.push(testObject);
                                    }
                                });
                            });
                            //sort the tests by name and assign the tests to the test list model for display in the select tests UI component
                            tabController.sampleTests = mergedSampleTests.sort((a, b) => (a.testName > b.testName) ? 1 : -1);
                        },
                        onError : function() {
                            tabController.sampleLoading = false;
                            if ( onError ) { onError(); }
                        }
                    })
                },
                removeTestFromSample: function(resultId = null, removeAll = false, callback) {
                    const tabController = this;
                    tabController.sampleLoading = true;
                    //Update Sample Data, Test Data
                    window.ajaxCall({
                        data : {
                            action: 'remove_test_from_sample',
                            sample_id: this.sampleData.SampleID,
                            result_id: resultId,
                            remove_all: removeAll
                        },
                        successMessage: 'Removed Tests from Sample.',
                        warningMessage: 'Could Not remove Tests from Sample. Try removing another way.',
                        onSuccess : function(data) {
                            let sampleData = data.data;
                            let mergedSampleTests = [];
                            sampleData.Tests.forEach(db_test => {
                                tabController.testList.forEach(testInfo => {
                                    if(db_test["TestId"] == parseInt(testInfo.id)) {
                                        let testObject = {
                                            "testId" : db_test["TestId"],
                                            "testName" : testInfo.testName,
                                            "resultId" : db_test["ResultId"],
                                            "sampleId" : db_test["SampleId"]
                                        };
                                        mergedSampleTests.push(testObject);
                                    }
                                });
                            });
                            //sort the tests by name and assign the tests to the test list model for display in the select tests UI component
                            tabController.sampleTests = mergedSampleTests.sort((a, b) => (a.testName > b.testName) ? 1 : -1);
                            if(callback) {
                                callback();
                            }
                        },
                        onError : function() {
                            tabController.sampleLoading = false;
                            if ( onError ) { onError(); }
                        }
                    })
                },
                addTestComboTests: function (testCombo, onSuccess = null, onError = null) {
                    if (!testCombo || !('id' in testCombo)) { return; }
                    const tabController = this;
                    window.ajaxCall({
                        data: {
                            action: 'get_sample_test_combo_tests',
                            test_combo_id: testCombo.id,
                            add_to_sample: true,
                            sample_id: tabController.sampleData.SampleID
                        },
                        successMessage: 'Successfully Added Test Combo Tests',
                        onSuccess: function (response) {
                            let sampleData = response.data;
                            let mergedSampleTests = [];
                            sampleData.Tests.forEach(test => {
                                tabController.testList.forEach(testInfo => {
                                    if(test["TestId"] == parseInt(testInfo.id)) {
                                        let testObject = {
                                            "testId" : test["TestId"],
                                            "testName" : testInfo.testName,
                                            "resultId" : test["ResultId"],
                                            "sampleId" : test["SampleId"]
                                        };
                                        mergedSampleTests.push(testObject);
                                    }
                                });
                            });
                            //sort the tests by name and assign the tests to the test list model for display in the select tests UI component
                            tabController.sampleTests = mergedSampleTests.sort((a, b) => (a.testName > b.testName) ? 1 : -1);
                        },
                        onError: function () {
                            if (onError) { onError(); }
                        },
                    });
                },
                getClientInformation: function(client_id = null) {
                    const tabController = this;
                    if(client_id) {
                        window.ajaxCall({
                            data: {
                                action: 'get_client_data',
                                client_id: client_id,
                            },
                            successMessage: 'Retrieved Client: ' + client_id,
                            onSuccess: function (response) {
                                tabController.jobClientName = response.data.ClientDisplayName;
                                tabController.jobClientId = client_id;
                            },
                            onError: function (error) {
                                console.error("Client Id is invalid.")
                                return;                            },
                        });
                    }
                    else {
                        console.error("Client Id is invalid.")
                        return;
                    }
                },
                openCreateTestListModal: function(name = null) {
                    var tabController = this;
                    window.InputModalManager.show({
                        title: 'Copy as New Client Test List',
                        inputText: this.sampleData ? this.sampleData['SampleDescription'] : '',
                        buttonText: 'Save',
                        callback: function (name) {
                            tabController.createClientTestList(true, name);
                        },
                    });
                },
                createClientTestList: function (eventOrIsLoop = false, name = null) {
                    var tabController = this;
                    window.ajaxCall({
                        data: {
                            action: 'add_client_test_list',
                            client_id: tabController.jobData && tabController.jobData.ClientID || null,
                            name: name,
                            test_ids: tabController.sampleTests ? tabController.sampleTests.map(test => test.id || test.testId) : [],
                        },
                        successMessage: 'Successfully Added Client Test List',
                        onSuccess: function () {
                            tabController.loadClientTestLists();
                        }
                    });
                },
                onClientTestListInSampleIDSelected: function (name) {
                    const tabController = this;
                    tabController.clearSampleTests(function() {
                        if (name !== null) {
                            tabController.addClientTestListTests(
                                tabController.clientTestLists && 
                                tabController.clientTestLists.find(list => name == list.text) || 
                                null
                            );
                        }
                    });
                },
                doElementAction: function (target, elClass, event) {
                    this.loadSample(target.dataset.sampleNumber, tab.show);
                },
            },

            computed: {
                clients: function () {
                    return this.$store.state.clients;
                },

                jobs: function () {
                    return this.$store.state.jobs;
                },
                samples: function () {
                    return this.$store.state.samples;
                },
                sampleDuplicationChecklist: function () {
                    return this.$store.state.sampleDuplicationChecklist;
                },

                preservedByOptions: function () {
                    return this.$store.state.preservedByOptions;
                },
                collectionMethodOptions: function () {
                    return this.$store.state.collectionMethodOptions;
                },
                matrixOptions: function () {
                    return this.$store.state.matrixOptions;
                },
                locationOptions: function () {
                    return this.$store.state.locationOptions;
                },
                testList: function () {
                    return this.$store.state.testList;
                },
                testCombos: function () {
                    return store.state.testComboList;
                },
            },

            watch: {
                jobData: {
                    handler() {
                        if (this.getUpdateLockLevel() == 0) {
                            const jobId = this.jobData ? this.jobData['JobID'] : null;
                            if (this.sampleJobId != jobID) {
                                this.sampleDataModified = true;
                                this.sampleJobId = jobId;
                                this.sampleData['JobId'] = jobId;
                                this.updateJobClientName();
                            }
                        }
                    },
                    deep: true,
                },
                sampleData: {
                    handler(newValue, oldValue) {
                        if (this.sampleNumber && this.getUpdateLockLevel() == 0) {
                            this.sampleDataModified = true;
                            this.updateSampleData(null, null);
                        }
                        // Outside of enable...
                        if (newValue['JobID'] != newValue['JobID']) {
                            this.updateJobClientName();
                        }
                    },
                    deep: true,
                },
                location: {
                    handler(newValue) {
                        if (newValue) {
                            if (this.sampleData['SampleLocationID'] != newValue.id) {
                                this.$set(this.sampleData, 'SampleLocationID', newValue.id);
                            }
                        }
                    }
                },
                sampleDuplicationChecklist: {
                    handler() {
                        if (this.getUpdateLockLevel() == 0) {
                            this.$store.dispatch('localUpdateSampleDuplicationChecklist', this.sampleDuplicationChecklist);
                        }
                    },
                    deep: true,
                },
                jobNumber: function (newValue, oldValue) {
                    if (newValue == oldValue) { return; }
                    //TODO: sometimes job samples table does not update when job for sample is changed.
                    this.loadJobData(newValue, false /* by Number */, () => {
                        const jobNumber = vmProject.JobNumber || null;
                        if (jobNumber && (newValue == jobNumber || oldValue == jobNumber)) {
                            projectTab && projectTab.drawTable();
                        }
                    });
                },
                sampleTests: function () {
                    this.sampleData['Tests'] = this.sampleTests ? this.sampleTests.map(function (test) {
                        let testObject = {};
                        testObject.testId = test.id ? test.id : test.testId;
                        testObject.resultId = test.resultId ? test.resultId : "";
                        return testObject;
                    }) : [];
                },
                sampleNumberInput: function (newValue) { this.checkForSample(); },
            }

        }));

        projectTab = AppTabs.getTab('project');
        vmProject = projectTab.controller;
    }

});